
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34381',
  depVersions: {
  "documents-public-ui": "static-1.34381",
  "client-types": "static-1.460",
  "documents-lib": "static-1.34386",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.2083",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4938",
  "highcharts": "static-8.103",
  "hs-promise-utils": "static-1.5544",
  "hs-test-utils": "static-1.7966",
  "hub-http": "static-1.6172",
  "hubspot-dlb": "static-2.1832",
  "HubStyleTokens": "static-2.11412",
  "I18n": "static-7.1611",
  "jasmine-immutable": "static-1.2969",
  "jasmine-runner": "static-1.6420",
  "lodash": "static-1.3",
  "quartz": "static-1.6957",
  "react": "static-7.185",
  "react-dlb": "static-1.78",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.70",
  "react-rhumb": "static-1.16617",
  "reporting-data": "static-1.67296",
  "reporting-testing-lib": "static-1.9229",
  "reporting-visualizations": "static-1.59372",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4720",
  "webpack-env": "static-1.54",
  "atom": "static-1.5023",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2449",
  "classnames": "static-2.10",
  "cssUtils": "static-1.779",
  "customer-data-filters-ui": "static-1.39566",
  "customer-data-objects": "static-1.7612",
  "customer-data-property-utils": "static-1.8034",
  "data-fetching-client": "static-1.9625",
  "enviro": "static-4.428",
  "FireAlarmUi": "static-1.4472",
  "flux-actions": "static-1.331",
  "FormsCommonComponents": "static-1.85690",
  "FormUrlGenerator": "static-2.4670",
  "foundations-components": "static-1.7832",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.4049",
  "HubStyle": "static-2.11720",
  "icons": "static-2.644",
  "immutable": "static-2.77",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7109",
  "metrics-js": "static-1.9542",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.388",
  "property-description-translator": "static-1.3798",
  "property-translator": "static-1.5353",
  "quartz-config": "static-1.735",
  "quartz-core": "static-1.6176",
  "quick-fetch": "static-1.3875",
  "raven": "static-3.5829",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-select-plus": "static-1.104",
  "react-utils": "static-2.5302",
  "react-virtualized": "static-2.98",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8121",
  "reference-resolvers-lite": "static-1.8045",
  "report-customization-components": "static-1.13010",
  "reporting-enablement": "static-1.22721",
  "reporting-reports": "static-1.66974",
  "reporting-snowflake": "static-1.55914",
  "reporting-ui-components": "static-2.64567",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4601",
  "sales-content-partitioning": "static-1.8888",
  "SalesContentIndexUI": "static-3.9165",
  "sanitize": "static-1.4423",
  "sanitize-text": "static-1.8094",
  "self-service-api": "static-1.10196",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1698",
  "signup-constants": "static-1.18745",
  "signup-ui-lego-core": "static-1.20755",
  "signup-ui-url-generator": "static-2.7989",
  "styled-components": "static-2.88",
  "StyleGuideUI": "static-3.486",
  "superstore": "static-1.4717",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10939",
  "ui-addon-i18n": "static-1.11101",
  "ui-addon-react-router-dom": "static-1.9496",
  "ui-addon-upgrades": "static-9.17912",
  "ui-asset-management-lib": "static-1.10956",
  "ui-images": "static-2.1139",
  "UIComponents": "static-3.8359",
  "usage-tracker": "static-1.7289",
  "usage-tracker-container": "static-1.7279",
  "usage-tracker-core": "static-1.7139",
  "usage-tracker-public": "static-1.7100",
  "viral-links-lib": "static-1.7003",
  "hs-promise-rejection-tracking": "static-1.5489",
  "raven-hubspot": "static-1.6136",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3361",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3234",
  "quartz-webpack": "static-1.3181",
  "ai-components-ui-library": "static-1.8801",
  "amplitude-session-replay-browser": "static-1.59",
  "foundations-assets": "static-1.4807",
  "foundations-theming": "static-1.4367",
  "quartz-auth": "static-1.632",
  "ui-business-units-lib": "static-1.8999",
  "usage-tracker-session-replay": "static-1.4975",
  "foundations-theming-base": "static-1.3352",
  "HeadJS": "static-2.741",
  "framer-motion": "static-1.71",
  "hs-test-utils-bend-plugin": "static-1.3077",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "hs-locale-management": "static-1.42",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4275",
  "csstype": "static-1.50",
  "quartz-head": "static-1.622",
  "web-vitals": "static-1.4",
  "frontend-preferences-client": "static-1.7878",
  "graphql": "static-1.81",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3549",
  "persist-promise": "static-1.3658",
  "quartz-i18n": "static-1.632",
  "reporting-client-types": "static-1.2465",
  "foundations-components-legacy": "static-1.857",
  "hs-story-utils": "static-1.9379",
  "react-flip-move": "static-1.69",
  "hub-http-shared-msw-handlers": "static-1.9842",
  "hubspotter-http": "static-1.4610",
  "sassPrefix": "static-1.155",
  "conversations-skeleton-state": "static-1.7199",
  "crm-message-bus": "static-1.42843",
  "customer-data-filters-ui-msw-helpers": "static-1.22001",
  "customer-data-objects-ui-components": "static-1.12976",
  "customer-data-reference-ui-components": "static-1.13110",
  "customer-data-ui-utilities": "static-1.9777",
  "framework-builder-read-service-client": "static-1.3968",
  "framework-data-schema-quick-fetch": "static-1.6734",
  "framework-data-schema-resolvers": "static-1.6829",
  "inbound-db-properties-service-client": "static-1.3799",
  "multi-account-reference-resolvers": "static-1.930",
  "onboarding-tours": "static-1.16501",
  "reporting-datasets-permissions-lib": "static-1.13515",
  "ui-addon-teams": "static-1.21478",
  "apollo-stack-hubspot": "static-3.85",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.68207",
  "customer-data-properties": "static-1.51362",
  "forms-ai-lib": "static-1.4237",
  "forms-utils-lib": "static-1.12481",
  "foundations-components-test-utils": "static-1.5315",
  "react-dnd-compat": "static-1.4571",
  "react-tinymce": "static-1.55091",
  "tinymce-config": "static-2.54217",
  "ui-gdpr-components": "static-1.10298",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4101",
  "floating-ui": "static-1.55",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.10",
  "tanstack-table": "static-1.54",
  "trellis-assets": "static-1.1670",
  "ui-fonts": "static-1.674",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.827",
  "mobile-manifest-mixins": "static-1.515",
  "module-federation": "static-1.22",
  "quartz-routing": "static-1.387",
  "quartz-test": "static-1.632",
  "quartz-tracking": "static-1.336",
  "batch-promise": "static-1.1501",
  "external-options-client-types": "static-1.4117",
  "react-colorpicker": "static-2.10161",
  "copilot-toolkit": "static-1.10975",
  "data-quality-ui-library": "static-1.12761",
  "html-to-image": "static-1.53",
  "onboarding-scopes": "static-1.6413",
  "reporting-action-components": "static-1.41157",
  "reporting-filters": "static-1.179",
  "reporting-insights-lib": "static-1.1575",
  "reporting-plugins": "static-1.10205",
  "ui-addon-draggable-compat": "static-2.4205",
  "ui-addon-opt": "static-4.8324",
  "zustand": "static-1.72",
  "growth-payments-core": "static-1.25212",
  "hubspot-apollo-client": "static-1.4827",
  "bend-plugin-chirp-manifest": "static-1.11",
  "chirp-fetch": "static-1.1836",
  "sales-templates-service-types-lib": "static-1.4126",
  "merchandise-lib": "static-1.262",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5789",
  "salesImages": "static-1.524",
  "ts-schema": "static-1.4036",
  "nested-table": "static-1.176",
  "timezone-utils": "static-2.5195",
  "bender-build-tools": "static-1.3123",
  "chatspot-core": "static-1.21034",
  "bend-plugin-foundations-theming": "static-1.2850",
  "stylex": "static-1.32",
  "hubspotter-http-shared-msw-handlers": "static-1.9840",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3755",
  "crm-pipelines-api-client-types": "static-1.4101",
  "multi-currency-client-types": "static-1.3650",
  "getting-started-shared-tasks": "static-1.18347",
  "growth-data-modal": "static-1.5347",
  "growth-onboarding-confetti": "static-1.3018",
  "growth-onboarding-next-action-utils": "static-1.1759",
  "navigation-components": "static-1.17847",
  "onboarding-tours-client": "static-1.4715",
  "onboarding-tours-utils": "static-1.567",
  "ui-shepherd-react": "static-3.10099",
  "ui-shepherd-tracker": "static-1.7480",
  "ui-universal-auth": "static-1.8912",
  "user-context": "static-1.5052",
  "cms-field-types": "static-1.4762",
  "content-icons-ui": "static-1.2212",
  "integrations-lib": "static-1.15950",
  "calling-global-api": "static-1.64323",
  "calling-internal-common": "static-1.31252",
  "calling-lifecycle-internal": "static-1.65705",
  "calling-lifecycle-messages": "static-1.57999",
  "commerce-products-lib": "static-1.9332",
  "crm-links": "static-1.6232",
  "customer-data-properties-shared-msw-handlers": "static-1.9169",
  "file-manager-components": "static-1.23468",
  "google-libphonenumber": "static-1.37",
  "hs-resources": "static-1.95",
  "inbounddb-objects-service-types": "static-1.4182",
  "meetings-icalendar-utils-lib": "static-1.582",
  "object-builder-ui-client": "static-1.48558",
  "pipeline-validation-client-types": "static-1.3924",
  "property-value-citations": "static-1.1976",
  "pulse": "static-1.506",
  "smart-property-lib": "static-1.6672",
  "tiered-pricing": "static-1.1098",
  "ui-addon-iframeable": "static-1.9004",
  "final-form": "static-1.69",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19741",
  "tinymce-themes": "static-1.56187",
  "data-token-picker": "static-1.16314",
  "hub-http-contrib": "static-1.2991",
  "interframe": "static-3.4712",
  "tinymce-data": "static-1.40302",
  "tinymce-plugins": "static-1.57331",
  "ui-addon-sales-email": "static-1.5161",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "magpie-lib": "static-1.5527",
  "magpie-types": "static-1.4987",
  "simple-logging-lib": "static-1.3000",
  "content-assistance-lib": "static-1.7674",
  "dashboard-lib": "static-1.81311",
  "ExportDialog": "static-6.10344",
  "hubspot-prosemirror": "static-1.18084",
  "hubspot-prosemirror-plugins": "static-1.18076",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8648",
  "campaign-roi-lib": "static-1.8926",
  "feedback-loader": "static-1.29203",
  "apollo-link-hub-http": "static-2.4599",
  "hubspot-apollo-cache": "static-1.286",
  "purchase-motions-api": "static-1.5792",
  "trials-service-types": "static-1.3854",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.124",
  "markdown-it": "static-1.6",
  "onboarding-data-sync-lib": "static-1.1877",
  "growth-onboarding-next-action-components": "static-1.1787",
  "user-context-client": "static-1.4561",
  "idb-keyval": "static-1.43",
  "nest": "static-1.177",
  "reactive-lib": "static-1.672",
  "unified-auth-core-lib": "static-1.707",
  "getting-started-shared-tasks-store": "static-1.17465",
  "integrations-error-boundary-lib": "static-1.13365",
  "integrations-tracking-lib": "static-1.5549",
  "native-integrations-shared-strings": "static-1.7734",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10322",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.426",
  "calling-error-reporting": "static-1.31258",
  "shared-worker-versioning": "static-1.10988",
  "calling-usage-tracker": "static-1.6493",
  "voice-sms-access-library": "static-1.771",
  "customer-data-tracking": "static-1.6836",
  "commerce-permissions": "static-1.716",
  "products-iframe-lib": "static-1.7773",
  "products-ui-components-shared-msw-handlers": "static-1.10224",
  "location-customization-utils-lib": "static-1.9087",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4104",
  "video-components-external": "static-1.11095",
  "video-data-lib": "static-1.34753",
  "bend-plugin-pulse": "static-1.9",
  "directed-graph": "static-1.886",
  "event-emitter": "static-1.899",
  "fast-json-patch": "static-1.62",
  "data-agent-kit": "static-1.113",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9925",
  "fsm": "static-1.3683",
  "policy-lib": "static-1.6723",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9988",
  "navigation-messaging": "static-1.7174",
  "FileManagerLib": "static-1.39108",
  "NamespacedHubStyle": "static-2.9021",
  "FileManagerCore": "static-1.38967",
  "codemirror": "static-5.94",
  "layout-dnd-components": "static-1.12344",
  "layout-dnd-utils": "static-1.11319",
  "react-codemirror": "static-1.10574",
  "ui-addon-emoji-picker": "static-1.9838",
  "ui-brand-identity-lib": "static-1.15001",
  "ui-addon-video-player": "static-1.8649",
  "ui-coaching-tips": "static-1.28396",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8479",
  "payment-link-components": "static-1.23382",
  "EmailSignatureEditor": "static-1.24260",
  "InboxConnectUtils": "static-4.14652",
  "universal-page-editor-lib": "static-1.2963",
  "google-sheets-integration-lib": "static-1.81",
  "microsoft-drive-integration-lib": "static-1.192",
  "calling-orchestration-schema": "static-1.35548",
  "sales-views-client-types": "static-1.4215",
  "crm-record-cards-service-types": "static-1.3569",
  "content-media-composition-data-lib": "static-1.12074",
  "content-media-compositions": "static-2.16081",
  "media-bridge-lib": "static-1.18837",
  "trellis-story-utils": "static-1.4466",
  "storybook-react": "static-1.32",
  "audio-components": "static-1.5839",
  "FileManagerImages": "static-1.36619",
  "video-components": "static-1.13098",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4482",
  "video-embed": "static-1.35587",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68282",
  "layout-data-lib": "static-1.9644",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6534",
  "commerce-tours-lib": "static-1.5998",
  "growth-onboarding-reliability": "static-1.5032",
  "sales-checkout-service-client": "static-1.3590",
  "draft-convert": "static-2.72",
  "draft-extend": "static-3.74",
  "draft-js": "static-5.77",
  "draft-plugins": "static-2.21580",
  "sales-email-signature-service-client": "static-1.3794",
  "social-insights-client-types": "static-1.21937",
  "outpost": "static-1.4140",
  "advanced-menus-core": "static-1.15047",
  "advanced-menus-lib": "static-1.11999",
  "ui-memberships-settings-lib": "static-1.33901",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15046",
  "simple-menus-lib": "static-1.16563"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34381",
  "client-types": "/client-types/static-1.460",
  "documents-lib": "/documents-lib/static-1.34386",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2083",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4938",
  "highcharts": "/highcharts/static-8.103",
  "hs-promise-utils": "/hs-promise-utils/static-1.5544",
  "hs-test-utils": "/hs-test-utils/static-1.7966",
  "hub-http": "/hub-http/static-1.6172",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "HubStyleTokens": "/HubStyleTokens/static-2.11412",
  "I18n": "/I18n/static-7.1611",
  "jasmine-immutable": "/jasmine-immutable/static-1.2969",
  "jasmine-runner": "/jasmine-runner/static-1.6420",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6957",
  "react": "/react/static-7.185",
  "react-dlb": "/react-dlb/static-1.78",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.70",
  "react-rhumb": "/react-rhumb/static-1.16617",
  "reporting-data": "/reporting-data/static-1.67296",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9229",
  "reporting-visualizations": "/reporting-visualizations/static-1.59372",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4720",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.5023",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2449",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.779",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39566",
  "customer-data-objects": "/customer-data-objects/static-1.7612",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8034",
  "data-fetching-client": "/data-fetching-client/static-1.9625",
  "enviro": "/enviro/static-4.428",
  "FireAlarmUi": "/FireAlarmUi/static-1.4472",
  "flux-actions": "/flux-actions/static-1.331",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85690",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4670",
  "foundations-components": "/foundations-components/static-1.7832",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyle": "/HubStyle/static-2.11720",
  "icons": "/icons/static-2.644",
  "immutable": "/immutable/static-2.77",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7109",
  "metrics-js": "/metrics-js/static-1.9542",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "property-description-translator": "/property-description-translator/static-1.3798",
  "property-translator": "/property-translator/static-1.5353",
  "quartz-config": "/quartz-config/static-1.735",
  "quartz-core": "/quartz-core/static-1.6176",
  "quick-fetch": "/quick-fetch/static-1.3875",
  "raven": "/raven/static-3.5829",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-utils": "/react-utils/static-2.5302",
  "react-virtualized": "/react-virtualized/static-2.98",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8121",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8045",
  "report-customization-components": "/report-customization-components/static-1.13010",
  "reporting-enablement": "/reporting-enablement/static-1.22721",
  "reporting-reports": "/reporting-reports/static-1.66974",
  "reporting-snowflake": "/reporting-snowflake/static-1.55914",
  "reporting-ui-components": "/reporting-ui-components/static-2.64567",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4601",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8888",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9165",
  "sanitize": "/sanitize/static-1.4423",
  "sanitize-text": "/sanitize-text/static-1.8094",
  "self-service-api": "/self-service-api/static-1.10196",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1698",
  "signup-constants": "/signup-constants/static-1.18745",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20755",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7989",
  "styled-components": "/styled-components/static-2.88",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "superstore": "/superstore/static-1.4717",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10939",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11101",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9496",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17912",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10956",
  "ui-images": "/ui-images/static-2.1139",
  "UIComponents": "/UIComponents/static-3.8359",
  "usage-tracker": "/usage-tracker/static-1.7289",
  "usage-tracker-container": "/usage-tracker-container/static-1.7279",
  "usage-tracker-core": "/usage-tracker-core/static-1.7139",
  "usage-tracker-public": "/usage-tracker-public/static-1.7100",
  "viral-links-lib": "/viral-links-lib/static-1.7003",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3361",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3234",
  "quartz-webpack": "/quartz-webpack/static-1.3181",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8801",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "foundations-assets": "/foundations-assets/static-1.4807",
  "foundations-theming": "/foundations-theming/static-1.4367",
  "quartz-auth": "/quartz-auth/static-1.632",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8999",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4975",
  "foundations-theming-base": "/foundations-theming-base/static-1.3352",
  "HeadJS": "/HeadJS/static-2.741",
  "framer-motion": "/framer-motion/static-1.71",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3077",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "hs-locale-management": "/hs-locale-management/static-1.42",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4275",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.622",
  "web-vitals": "/web-vitals/static-1.4",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7878",
  "graphql": "/graphql/static-1.81",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3549",
  "persist-promise": "/persist-promise/static-1.3658",
  "quartz-i18n": "/quartz-i18n/static-1.632",
  "reporting-client-types": "/reporting-client-types/static-1.2465",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.857",
  "hs-story-utils": "/hs-story-utils/static-1.9379",
  "react-flip-move": "/react-flip-move/static-1.69",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9842",
  "hubspotter-http": "/hubspotter-http/static-1.4610",
  "sassPrefix": "/sassPrefix/static-1.155",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7199",
  "crm-message-bus": "/crm-message-bus/static-1.42843",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22001",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12976",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13110",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9777",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3968",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6734",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6829",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3799",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.930",
  "onboarding-tours": "/onboarding-tours/static-1.16501",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13515",
  "ui-addon-teams": "/ui-addon-teams/static-1.21478",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.85",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.68207",
  "customer-data-properties": "/customer-data-properties/static-1.51362",
  "forms-ai-lib": "/forms-ai-lib/static-1.4237",
  "forms-utils-lib": "/forms-utils-lib/static-1.12481",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5315",
  "react-dnd-compat": "/react-dnd-compat/static-1.4571",
  "react-tinymce": "/react-tinymce/static-1.55091",
  "tinymce-config": "/tinymce-config/static-2.54217",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10298",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4101",
  "floating-ui": "/floating-ui/static-1.55",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.10",
  "tanstack-table": "/tanstack-table/static-1.54",
  "trellis-assets": "/trellis-assets/static-1.1670",
  "ui-fonts": "/ui-fonts/static-1.674",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.827",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.515",
  "module-federation": "/module-federation/static-1.22",
  "quartz-routing": "/quartz-routing/static-1.387",
  "quartz-test": "/quartz-test/static-1.632",
  "quartz-tracking": "/quartz-tracking/static-1.336",
  "batch-promise": "/batch-promise/static-1.1501",
  "external-options-client-types": "/external-options-client-types/static-1.4117",
  "react-colorpicker": "/react-colorpicker/static-2.10161",
  "copilot-toolkit": "/copilot-toolkit/static-1.10975",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12761",
  "html-to-image": "/html-to-image/static-1.53",
  "onboarding-scopes": "/onboarding-scopes/static-1.6413",
  "reporting-action-components": "/reporting-action-components/static-1.41157",
  "reporting-filters": "/reporting-filters/static-1.179",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1575",
  "reporting-plugins": "/reporting-plugins/static-1.10205",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4205",
  "ui-addon-opt": "/ui-addon-opt/static-4.8324",
  "zustand": "/zustand/static-1.72",
  "growth-payments-core": "/growth-payments-core/static-1.25212",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4827",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.11",
  "chirp-fetch": "/chirp-fetch/static-1.1836",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4126",
  "merchandise-lib": "/merchandise-lib/static-1.262",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5789",
  "salesImages": "/salesImages/static-1.524",
  "ts-schema": "/ts-schema/static-1.4036",
  "nested-table": "/nested-table/static-1.176",
  "timezone-utils": "/timezone-utils/static-2.5195",
  "bender-build-tools": "/bender-build-tools/static-1.3123",
  "chatspot-core": "/chatspot-core/static-1.21034",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2850",
  "stylex": "/stylex/static-1.32",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9840",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3755",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4101",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3650",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18347",
  "growth-data-modal": "/growth-data-modal/static-1.5347",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3018",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1759",
  "navigation-components": "/navigation-components/static-1.17847",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4715",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.567",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10099",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7480",
  "ui-universal-auth": "/ui-universal-auth/static-1.8912",
  "user-context": "/user-context/static-1.5052",
  "cms-field-types": "/cms-field-types/static-1.4762",
  "content-icons-ui": "/content-icons-ui/static-1.2212",
  "integrations-lib": "/integrations-lib/static-1.15950",
  "calling-global-api": "/calling-global-api/static-1.64323",
  "calling-internal-common": "/calling-internal-common/static-1.31252",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65705",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57999",
  "commerce-products-lib": "/commerce-products-lib/static-1.9332",
  "crm-links": "/crm-links/static-1.6232",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9169",
  "file-manager-components": "/file-manager-components/static-1.23468",
  "google-libphonenumber": "/google-libphonenumber/static-1.37",
  "hs-resources": "/hs-resources/static-1.95",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4182",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.582",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48558",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3924",
  "property-value-citations": "/property-value-citations/static-1.1976",
  "pulse": "/pulse/static-1.506",
  "smart-property-lib": "/smart-property-lib/static-1.6672",
  "tiered-pricing": "/tiered-pricing/static-1.1098",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9004",
  "final-form": "/final-form/static-1.69",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19741",
  "tinymce-themes": "/tinymce-themes/static-1.56187",
  "data-token-picker": "/data-token-picker/static-1.16314",
  "hub-http-contrib": "/hub-http-contrib/static-1.2991",
  "interframe": "/interframe/static-3.4712",
  "tinymce-data": "/tinymce-data/static-1.40302",
  "tinymce-plugins": "/tinymce-plugins/static-1.57331",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5161",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "magpie-lib": "/magpie-lib/static-1.5527",
  "magpie-types": "/magpie-types/static-1.4987",
  "simple-logging-lib": "/simple-logging-lib/static-1.3000",
  "content-assistance-lib": "/content-assistance-lib/static-1.7674",
  "dashboard-lib": "/dashboard-lib/static-1.81311",
  "ExportDialog": "/ExportDialog/static-6.10344",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18084",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18076",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8648",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8926",
  "feedback-loader": "/feedback-loader/static-1.29203",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4599",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.286",
  "purchase-motions-api": "/purchase-motions-api/static-1.5792",
  "trials-service-types": "/trials-service-types/static-1.3854",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.124",
  "markdown-it": "/markdown-it/static-1.6",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1877",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1787",
  "user-context-client": "/user-context-client/static-1.4561",
  "idb-keyval": "/idb-keyval/static-1.43",
  "nest": "/nest/static-1.177",
  "reactive-lib": "/reactive-lib/static-1.672",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.707",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17465",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13365",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5549",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7734",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10322",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.426",
  "calling-error-reporting": "/calling-error-reporting/static-1.31258",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10988",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6493",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.771",
  "customer-data-tracking": "/customer-data-tracking/static-1.6836",
  "commerce-permissions": "/commerce-permissions/static-1.716",
  "products-iframe-lib": "/products-iframe-lib/static-1.7773",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10224",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9087",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4104",
  "video-components-external": "/video-components-external/static-1.11095",
  "video-data-lib": "/video-data-lib/static-1.34753",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.9",
  "directed-graph": "/directed-graph/static-1.886",
  "event-emitter": "/event-emitter/static-1.899",
  "fast-json-patch": "/fast-json-patch/static-1.62",
  "data-agent-kit": "/data-agent-kit/static-1.113",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9925",
  "fsm": "/fsm/static-1.3683",
  "policy-lib": "/policy-lib/static-1.6723",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9988",
  "navigation-messaging": "/navigation-messaging/static-1.7174",
  "FileManagerLib": "/FileManagerLib/static-1.39108",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9021",
  "FileManagerCore": "/FileManagerCore/static-1.38967",
  "codemirror": "/codemirror/static-5.94",
  "layout-dnd-components": "/layout-dnd-components/static-1.12344",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11319",
  "react-codemirror": "/react-codemirror/static-1.10574",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9838",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15001",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8649",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28396",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8479",
  "payment-link-components": "/payment-link-components/static-1.23382",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24260",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14652",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2963",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.81",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.192",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35548",
  "sales-views-client-types": "/sales-views-client-types/static-1.4215",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3569",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12074",
  "content-media-compositions": "/content-media-compositions/static-2.16081",
  "media-bridge-lib": "/media-bridge-lib/static-1.18837",
  "trellis-story-utils": "/trellis-story-utils/static-1.4466",
  "storybook-react": "/storybook-react/static-1.32",
  "audio-components": "/audio-components/static-1.5839",
  "FileManagerImages": "/FileManagerImages/static-1.36619",
  "video-components": "/video-components/static-1.13098",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4482",
  "video-embed": "/video-embed/static-1.35587",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68282",
  "layout-data-lib": "/layout-data-lib/static-1.9644",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6534",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5998",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5032",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3590",
  "draft-convert": "/draft-convert/static-2.72",
  "draft-extend": "/draft-extend/static-3.74",
  "draft-js": "/draft-js/static-5.77",
  "draft-plugins": "/draft-plugins/static-2.21580",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3794",
  "social-insights-client-types": "/social-insights-client-types/static-1.21937",
  "outpost": "/outpost/static-1.4140",
  "advanced-menus-core": "/advanced-menus-core/static-1.15047",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11999",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33901",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15046",
  "simple-menus-lib": "/simple-menus-lib/static-1.16563"
}
};
